import { DateTime } from 'luxon';

export class DocumentHelper {
  static isExpired(date: string): boolean {
    const expirationDate: DateTime = DateTime.fromISO(date);
    const currentDate: DateTime = DateTime.now();
    return currentDate > expirationDate;
  }
}
